import * as Icon from "@ant-design/icons";
import { Button, Checkbox, Col, DatePicker, DatePickerProps, Drawer, Dropdown, Flex, Form, Image, MenuProps, Modal, Row, Select, Tooltip, Typography } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import * as PhosphorIcon from "phosphor-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Filtro } from "../../../../components/filtroComponent/filtro";
import FiltroComponent from "../../../../components/filtroComponent/filtroComponent";
import MensagemModal from "../../../../components/modal/mensagem";
import AcoesComponent from "../../../../components/table/acoesComponent";
import TableComponent from "../../../../components/table/tableComponent";
import { BuscarContaPorIdModel } from "../../../../models/contaFinanceira/chamadas/buscarContaPorIdModel";
import { ExportacaoContabilModel } from "../../../../models/contaFinanceira/exportacaoContabilModel";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";
import { BuscarLancamentoBancarioModel } from "../../../../models/lancamentoBancario/buscarLancamentoBancarioModel";
import { LancamentoBancarioModel } from "../../../../models/lancamentoBancario/lancamentoBancarioModel";
import { LancamentoFinanceiroToExcludeModel } from "../../../../models/lancamentoBancario/lancamentoFinanceiroToExcludeModel";
import { ItemMenuAcoes } from "../../../../models/sistema/itemMenuAcoes";
import { setIdEmpresaPermissao, setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import { setEntityContaFinanceira, setOrigemCadastro, setTipoAcao, setTipoCadastro } from "../../../../redux/slices/contaFinanceira/contaFinanceiraSlice";
import {
  resetDetalheTransferencia,
  setBuscaLancamentoBancario,
  setEntityLancamentoBancario,
  setModalCadastrarLancamentoBancario,
  setModalDeletarLancamentoBancario,
  setPageLancamentoBancario,
} from "../../../../redux/slices/lancamentoBancario/lancamentoBancarioSlice";
import { setRelatorioLancamentoFinanceiro } from "../../../../redux/slices/relatorio/relatorioSlice";
import { listarTipoArquivoAnexo } from "../../../../services/arquivoAnexoService";
import { buscarCategoriaEmpresa } from "../../../../services/categoriaEmpresaService";
import { buscarContaBanco } from "../../../../services/contaBancoService";
import { buscarContaFinanceiraPorId, listarExportacaoContabil } from "../../../../services/contaFinanceiraService";
import { buscarEmpresa } from "../../../../services/empresaService";
import { buscarFormaPagamentoRecebimento } from "../../../../services/formaPagamentoRecebimentoService";
import {
  buscarDetalheLancamentoFinanceiroContaFinanceira,
  buscarDetalheLancamentoFinanceiroTransferenciaBancaria,
  buscarLancamentoBancario,
  deletarLancamentoBancario,
} from "../../../../services/lancamentoBancarioService";
import { gerarRelatorioLancamentoBancario } from "../../../../services/relatorioService";
import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";
import { verificarPermissaoEmpresa } from "../../../../util/functions/verificarPermissaoEmpresa";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { toastError, toastWarning } from "../../../../util/toast";
import VisualizarArquivosLancamento from "../../modals/arquivos";
import ModalLançamento from "../../modals/cadastrar";
import VisualizarLancamentoBancario from "../../modals/vizualizar";
import "./style/index.scss";

dayjs.locale("pt-br");

enum EntidadeParaRemover {
  Transferencia = "Transferencia",
  ContaFinanceira = "ContaFinanceira",
  Pagamento = "Pagamento",
}

const tipoDataOptions = [
  { label: "Sorteio", value: "SORT" },
  { label: "Lançamento", value: "LANC" },
];

const GeralPage = () => {
  //estados globais
  const lancamentoBancarioState = useAppSelector((state) => state.lancamentoBancario);
  const empresaState = useAppSelector((state) => state.empresa);
  const configuracoesState = useAppSelector((state) => state.configuracoes);
  const persistedState = useAppSelector((state) => state.persisted);
  const formaPagamentoRecebimentoState = useAppSelector((state) => state.formaPagamentoRecebimento);
  const arquivoAnexoState = useAppSelector((state) => state.arquivoAnexo);
  const categoriaEmpresaState = useAppSelector((state) => state.categoriaEmpresa);

  //hooks
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  //estados locais
  const [form] = Form.useForm<any>();
  const [openFiltros, setOpenFiltros] = useState<boolean>(false);
  const [idEmpresa, setIdEmpresa] = useState<number | null>(null);
  const [entityToDelete, setEntityToDelete] = useState<LancamentoFinanceiroToExcludeModel>({} as LancamentoFinanceiroToExcludeModel);
  const [mensagemModal, setMensagemModal] = useState<string>("");
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [openVisualizarArquivos, setOpenVisualizarArquivos] = useState<boolean>(false);
  const [exportandoCsv, setExportandoCsv] = useState<boolean>(false);

  const checkboxOptions = [
    { label: "Não realizado", value: "Não realizado" },
    { label: "Realizado", value: "Realizado" },
    { label: "Vencido", value: "Vencido" },
  ];

  const editar = Object.values(lancamentoBancarioState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("LANÇAMENTOS FINANCEIROS"));
    if (categoriaEmpresaState.list.length === 0) dispatch(buscarCategoriaEmpresa());
    if (formaPagamentoRecebimentoState.list.length === 0) dispatch(buscarFormaPagamentoRecebimento(""));
    if (arquivoAnexoState.listTipo.length === 0) dispatch(listarTipoArquivoAnexo("cfin"));
    if (empresaState.list.length === 0) dispatch(buscarEmpresa(empresaState.busca));

    form.setFieldsValue({
      tipoDataFiltro: "SORT",
      status: ["Não realizado", "Realizado", "Vencido"],
      idEmpresa: null,
      dataInicio: dayjs(lancamentoBancarioState.busca.dataInicio),
      dataFim: dayjs(lancamentoBancarioState.busca.dataFim),
    });
    if (lancamentoBancarioState.busca.idEmpresa !== 0) {
      setIdEmpresa(lancamentoBancarioState.busca.idEmpresa);
      dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: lancamentoBancarioState.busca.idEmpresa }));
      form.setFieldsValue({
        idEmpresa: lancamentoBancarioState.busca.idEmpresa,
      });
      dispatch(buscarLancamentoBancario(lancamentoBancarioState.busca));
    }
    if (persistedState.user.empresa !== null) {
      var busca = { ...lancamentoBancarioState.busca };
      busca.idEmpresa = persistedState.user.empresa.idEmpresa;
      setIdEmpresa(persistedState.user.empresa.idEmpresa);
      dispatch(setBuscaLancamentoBancario(busca));
      dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: persistedState.user.empresa.idEmpresa }));
      dispatch(buscarLancamentoBancario(busca));
    }
    if (configuracoesState.filtrosFormatado.length > 0) {
      setOpenFiltros(true);
    }
  }, []);

  const goCadastrar = async () => {
    try {
      await form.validateFields();
      dispatch(setEntityLancamentoBancario({}));
      dispatch(resetDetalheTransferencia());
      dispatch(setModalCadastrarLancamentoBancario(true));
    } catch (e) {}
  };

  const goEditar = (value: LancamentoBancarioModel) => {
    dispatch(buscarDetalheLancamentoFinanceiroTransferenciaBancaria(value.id ?? 0));
    dispatch(setModalCadastrarLancamentoBancario(true));
  };

  const closeModalCadastrar = () => {
    dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: lancamentoBancarioState.busca.idEmpresa }));
    dispatch(setModalCadastrarLancamentoBancario(false));
  };

  const goDeletar = (value: LancamentoBancarioModel, entidade: EntidadeParaRemover, msg: string) => {
    setMensagemModal(msg);
    dispatch(setEntityLancamentoBancario(value));
    setEntityToDelete({
      id: value.id,
      tipoLancamento: value.tipoLancamento,
      entidadeParaRemover: entidade,
    } as LancamentoFinanceiroToExcludeModel);
    dispatch(setModalDeletarLancamentoBancario(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarLancamentoBancario(false));
  };

  const onChangeEmpresa = (value: number) => {
    dispatch(setIdEmpresaPermissao(value));

    setIdEmpresa(value);

    let busca: BuscarLancamentoBancarioModel = { ...lancamentoBancarioState.busca, idEmpresa: value, filtros: configuracoesState.filtrosFormatado };

    dispatch(setBuscaLancamentoBancario(busca));
    dispatch(buscarLancamentoBancario(busca));
    dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: value }));
  };

  const onChangeCheckbox = (list: any[]) => {
    let busca: BuscarLancamentoBancarioModel = { ...lancamentoBancarioState.busca, filtros: configuracoesState.filtrosFormatado };

    list.includes("Não realizado") ? (busca.naoRealizado = true) : (busca.naoRealizado = false);
    list.includes("Realizado") ? (busca.realizado = true) : (busca.realizado = false);
    list.includes("Vencido") ? (busca.vencido = true) : (busca.vencido = false);

    dispatch(setBuscaLancamentoBancario(busca));
    dispatch(buscarLancamentoBancario(busca));
  };

  const onChangeDataInicio = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca: BuscarLancamentoBancarioModel = { ...lancamentoBancarioState.busca, filtros: configuracoesState.filtrosFormatado, dataInicio: dayjs(value).toDate() };

    dispatch(setBuscaLancamentoBancario(busca));
    dispatch(buscarLancamentoBancario(busca));
  };

  const onChangeDataFim = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca: BuscarLancamentoBancarioModel = { ...lancamentoBancarioState.busca, filtros: configuracoesState.filtrosFormatado, dataFim: dayjs(value).toDate() };

    dispatch(setBuscaLancamentoBancario(busca));
    dispatch(buscarLancamentoBancario(busca));
  };

  //conta financeira
  const goCadastrarContaFinanceira = async (tipo: string) => {
    try {
      await form.validateFields();
      dispatch(setEntityContaFinanceira({}));
      dispatch(setOrigemCadastro("lancamento"));
      dispatch(setTipoCadastro(tipo));
      dispatch(setTipoAcao("cadastrar"));
      dispatch(setPageLancamentoBancario("cadastrar"));
    } catch (e) {}
  };

  const goEditarContaFinanceira = async (value: LancamentoBancarioModel) => {
    let params: BuscarContaPorIdModel = {
      id: value.id,
      pagamentoRecebimento: value.tipoLancamento === "Pagamento" || value.tipoLancamento === "Recebimento" ? true : false,
    };

    let result = await dispatch(buscarContaFinanceiraPorId(params));

    dispatch(setEntityContaFinanceira(result.payload[0]));
    dispatch(setOrigemCadastro("lancamento"));
    dispatch(setTipoCadastro(result.payload[0].receitaDespesa === "R" ? "receita" : "despesa"));
    dispatch(setTipoAcao("editar"));
    dispatch(setPageLancamentoBancario("cadastrar"));
  };

  const goDuplicarContaFinanceira = async (value: LancamentoBancarioModel) => {
    let params: BuscarContaPorIdModel = {
      id: value.id,
      pagamentoRecebimento: value.tipoLancamento === "Pagamento" || value.tipoLancamento === "Recebimento" ? true : false,
    };

    let result = await dispatch(buscarContaFinanceiraPorId(params));

    dispatch(setEntityContaFinanceira(result.payload[0]));
    dispatch(setOrigemCadastro("lancamento"));
    dispatch(setTipoCadastro(result.payload[0].receitaDespesa === "R" ? "receita" : "despesa"));
    dispatch(setTipoAcao("duplicar"));
    dispatch(setPageLancamentoBancario("cadastrar"));
  };

  const goRealizarContaFinanceira = async (value: LancamentoBancarioModel) => {
    let params: BuscarContaPorIdModel = {
      id: value.id,
      pagamentoRecebimento: value.tipoLancamento === "Pagamento" || value.tipoLancamento === "Recebimento" ? true : false,
    };

    let result = await dispatch(buscarContaFinanceiraPorId(params));

    dispatch(setEntityContaFinanceira(result.payload[0]));
    dispatch(setTipoCadastro(result.payload[0].receitaDespesa === "R" ? "receita" : "despesa"));
    dispatch(setOrigemCadastro("lancamento"));
    dispatch(setPageLancamentoBancario("pagamentos"));
  };

  const goVisualizarArquivos = (value: LancamentoBancarioModel) => {
    dispatch(setEntityLancamentoBancario(value));
    setOpenVisualizarArquivos(true);
  };

  const closeVisualizarArquivo = () => {
    setOpenVisualizarArquivos(false);
  };

  const onChangeMostrarFiltros = async () => {
    try {
      await form.validateFields();
      setOpenFiltros(!openFiltros);
    } catch (e) {}
  };

  const onChangeTipoData = (value: string) => {
    let busca: BuscarLancamentoBancarioModel = { ...lancamentoBancarioState.busca, filtros: configuracoesState.filtrosFormatado, tipoDataFiltro: value };

    dispatch(setBuscaLancamentoBancario(busca));
    dispatch(buscarLancamentoBancario(busca));
  };

  const exportarCsv = async () => {
    try {
      setExportandoCsv(true);
      await form.validateFields();

      const valoresFormulario = form.getFieldsValue();
      const dataInicioSelecionada = dayjs(valoresFormulario.dataInicio).format("YYYY-MM-DD");
      const dataFimSelecionada = dayjs(valoresFormulario.dataFim).format("YYYY-MM-DD");

      const empresaSelecionada =
        valoresFormulario.idEmpresa ??
        idEmpresa ??
        (lancamentoBancarioState.busca.idEmpresa && lancamentoBancarioState.busca.idEmpresa !== 0 ? lancamentoBancarioState.busca.idEmpresa : null) ??
        persistedState.user.empresa?.idEmpresa ??
        null;

      if (!empresaSelecionada) {
        toastWarning("Selecione uma empresa para exportar");
        setExportandoCsv(false);
        return;
      }

      const filtrosAvancados = configuracoesState.filtrosFormatado && configuracoesState.filtrosFormatado.length > 0 ? JSON.stringify(configuracoesState.filtrosFormatado) : null;

      const registros = await dispatch(
        listarExportacaoContabil({
          dataInicio: dataInicioSelecionada,
          dataFim: dataFimSelecionada,
          idEmpresa: empresaSelecionada,
          jsonFiltroAvancado: filtrosAvancados,
        }),
      ).unwrap();

      if (!registros || registros.length === 0) {
        toastWarning("Nenhum registro encontrado para exportação");
        setExportandoCsv(false);
        return;
      }

      const obterValor = (item: ExportacaoContabilModel | Record<string, any>, chave: string) => {
        const chaveAlternativa = chave.charAt(0).toUpperCase() + chave.slice(1);
        return (item as any)?.[chave] ?? (item as any)?.[chaveAlternativa] ?? null;
      };

      const formatadorNumero = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: false,
      });

      const sanitizarCampo = (valor: string | number | null | undefined, formatarNumero = false) => {
        if (valor === null || valor === undefined || valor === "") {
          return "";
        }

        let texto = "";

        if (formatarNumero) {
          const numero = Number(valor);
          if (!Number.isNaN(numero) && Number.isFinite(numero)) {
            texto = formatadorNumero.format(numero);
          } else {
            texto = String(valor);
          }
        } else {
          texto = String(valor);
        }

        texto = texto.replace(/\r?\n/g, " ");
        const precisaAspas = texto.includes(";") || texto.includes('"');
        const textoEscapado = texto.replace(/\"/g, '""');

        return precisaAspas ? `"${textoEscapado}"` : textoEscapado;
      };

      const header = ["Valor", "Debito", "Credito", "Fornecedor/Cliente", "Data"];
      const linhas = (registros as (ExportacaoContabilModel & Record<string, any>)[]).map((item) => {
        const valor = obterValor(item, "valor");
        const debito = obterValor(item, "debito");
        const credito = obterValor(item, "credito");
        const razaoSocial = obterValor(item, "razaoSocial");
        const data = obterValor(item, "data");

        const dataFormatada = data ? (dayjs(data).isValid() ? dayjs(data).format("YYYY-MM-DD") : String(data)) : "";

        return [sanitizarCampo(valor, true), sanitizarCampo(debito), sanitizarCampo(credito), sanitizarCampo(razaoSocial), sanitizarCampo(dataFormatada)].join(";");
      });

      const csv = [header.join(";"), ...linhas].join("\n");
      const csvComBom = `\uFEFF${csv}`;
      const blob = new Blob([csvComBom], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `exportacao-contabil-${dayjs().format("YYYYMMDDHHmmss")}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error: any) {
      if (!error?.errorFields) {
        toastError(error?.message ?? "Erro ao exportar registros");
      }
    } finally {
      setExportandoCsv(false);
    }
  };

  const atualizar = async () => {
    try {
      await form.validateFields();
      let busca: BuscarLancamentoBancarioModel = { ...lancamentoBancarioState.busca, filtros: configuracoesState.filtrosFormatado };
      dispatch(buscarLancamentoBancario(busca));
    } catch (e) {}
  };

  const somarEntradas = () => {
    let soma = 0;
    lancamentoBancarioState.list.forEach((a: LancamentoBancarioModel) => {
      if (a.tipo !== "SLDP" && a.tipo !== "SLDI" && a.tipo !== "SLDF" && a.es === 1) {
        soma += a.valorTransacao ?? 0;
      }
    });
    return soma;
  };

  const somarSaidas = () => {
    let soma = 0;
    lancamentoBancarioState.list.forEach((a: LancamentoBancarioModel) => {
      if (a.tipo !== "SLDP" && a.tipo !== "SLDI" && a.tipo !== "SLDF" && a.es === -1) {
        soma += a.valorTransacao ?? 0;
      }
    });
    return soma;
  };

  const onCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const goVisualizar = (value: LancamentoBancarioModel) => {
    dispatch(setEntityLancamentoBancario(value));
    if (value.tipoLancamento === "Transferência") {
      dispatch(buscarDetalheLancamentoFinanceiroTransferenciaBancaria(value.id ?? 0));
    } else {
      dispatch(buscarDetalheLancamentoFinanceiroContaFinanceira({ idOrigem: value.id ?? 0, tipo: value.tipo }));
    }
    setOpenDrawer(true);
  };

  const itemsNovo: MenuProps["items"] = [
    {
      label: "Nova Transferência",
      key: "1",
      onClick: goCadastrar,
    },
    {
      label: "Nova Conta a Pagar",
      key: "2",
      onClick: () => goCadastrarContaFinanceira("despesa"),
    },
    {
      label: "Nova Conta a Receber",
      key: "3",
      onClick: () => goCadastrarContaFinanceira("receita"),
    },
  ];

  const carregarRelatorio = async () => {
    try {
      await form.validateFields();
      localStorage.clear();

      const list = lancamentoBancarioState.list;
      const totalLength = list.length;
      const third = Math.floor(totalLength / 3);

      const part1 = list.slice(0, third);
      const part2 = list.slice(third, third * 2);
      const part3 = list.slice(third * 2);

      localStorage.setItem("lancamentoBancarioState_part1", JSON.stringify(part1));
      localStorage.setItem("lancamentoBancarioState_part2", JSON.stringify(part2));
      localStorage.setItem("lancamentoBancarioState_part3", JSON.stringify(part3));

      localStorage.setItem("lancamentoBancarioState_busca", JSON.stringify(lancamentoBancarioState.busca));

      localStorage.setItem("empresaState", JSON.stringify(empresaState));
      localStorage.setItem("configuracoesState", JSON.stringify(configuracoesState));
      let total = 0;
      for (let key in localStorage) {
        if (localStorage.hasOwnProperty(key)) {
          total += (localStorage[key].length + key.length) * 2;
        }
      }
      window.open(window.location.origin + "/relatorioLancamento", "_blank");
    } catch (e) {}
  };

  const carregarRelatorioPorPlano = async () => {
    try {
      await form.validateFields();
      localStorage.clear();

      let busca: BuscarLancamentoBancarioModel = {
        ...lancamentoBancarioState.busca,
        filtros: configuracoesState.filtrosFormatado,
        idEmpresa: parseInt(lancamentoBancarioState.busca.idEmpresa.toString()),
      };

      let result = await dispatch(gerarRelatorioLancamentoBancario(busca));

      if (result.type.includes("fulfilled")) {
        dispatch(setRelatorioLancamentoFinanceiro(result.payload));

        const list = result.payload;
        const totalLength = list.length;
        const third = Math.floor(totalLength / 3);

        const part1 = list.slice(0, third);
        const part2 = list.slice(third, third * 2);
        const part3 = list.slice(third * 2);

        localStorage.setItem("listLancamentos_part1", JSON.stringify(part1));
        localStorage.setItem("listLancamentos_part2", JSON.stringify(part2));
        localStorage.setItem("listLancamentos_part3", JSON.stringify(part3));

        localStorage.setItem("empresaState", JSON.stringify(empresaState));
        localStorage.setItem("configuracoesState", JSON.stringify(configuracoesState));
        localStorage.setItem("lancamentoBancarioState_busca", JSON.stringify(lancamentoBancarioState.busca));

        window.open(window.location.origin + "/relatorioLancamentoBancario", "_blank");
      }
    } catch (e) {}
  };

  const itemsRelatorio: MenuProps["items"] = [
    {
      label: "Lançamentos",
      key: "1",
      onClick: carregarRelatorio,
      disabled: lancamentoBancarioState.loading,
    },
    {
      label: "Lançamentos por plano de conta",
      key: "2",
      onClick: carregarRelatorioPorPlano,
      disabled: lancamentoBancarioState.loading,
    },
    {
      label: exportandoCsv ? "Exportando CSV..." : "Exportar CSV",
      key: "3",
      onClick: exportarCsv,
      disabled: lancamentoBancarioState.loading || exportandoCsv,
      icon: exportandoCsv ? <Icon.LoadingOutlined spin /> : <Icon.DownloadOutlined />,
    },
  ];

  const itemsTransferencia: ItemMenuAcoes[] = [
    {
      label: "Atualizar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item, EntidadeParaRemover.Transferencia, "Deseja remover a transferência?"),
    },
  ];

  const itemsContaFinanceira: ItemMenuAcoes[] = [
    {
      label: "Realizar",
      key: "1",
      icon: <Icon.CheckCircleOutlined />,
      function: (item: any) => goRealizarContaFinanceira(item),
      disabled: (item: any) => item.tipo === "REAL",
    },
    {
      label: "Alterar",
      key: "2",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditarContaFinanceira(item),
    },
    {
      label: "Duplicar",
      key: "3",
      icon: <PhosphorIcon.Copy color="#212937" weight="light" />,
      function: (item: any) => goDuplicarContaFinanceira(item),
    },
    {
      label: "Cancelar",
      key: "4",
      icon: <PhosphorIcon.Prohibit />,
      function: (item: any) => goDeletar(item, EntidadeParaRemover.ContaFinanceira, "Deseja cancelar a conta financeira?"),
    },
  ];

  const itemsPagamento: ItemMenuAcoes[] = [
    {
      label: "Remover pagamento",
      key: "1",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item, EntidadeParaRemover.Pagamento, "Deseja remover o pagamento?"),
    },
    {
      label: "Alterar lançamento",
      key: "2",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditarContaFinanceira(item),
    },
    {
      label: "Duplicar lançamento",
      key: "3",
      icon: <PhosphorIcon.Copy color="#212937" weight="light" />,
      function: (item: any) => goDuplicarContaFinanceira(item),
    },
    {
      label: "Cancelar lançamento",
      key: "4",
      icon: <PhosphorIcon.Prohibit />,
      function: (item: any) => goDeletar(item, EntidadeParaRemover.ContaFinanceira, "Deseja cancelar a conta financeira?"),
    },
  ];

  const columns: ColumnsType<LancamentoBancarioModel> = [
    {
      title: "DATA",
      dataIndex: "data",
      align: "center",
      width: 120,
      render: (_, record) => <>{record.data !== null && !record.tipoLancamento.includes("SALDO") && dayjs(record.data).format("DD/MM/YYYY")}</>,
    },
    {
      title: "CLIENTE/FORNECEDOR",
      dataIndex: "clienteFornecedor",
      render: (_, record) => (
        <Typography.Text
          style={{ width: 300 }}
          ellipsis={{ tooltip: !(record.tipoLancamento.includes("SALDO") || record.tipoLancamento.includes("Transferência")) ? record.clienteFornecedor : record.historicoTransferencia }}
        >
          {!(record.tipoLancamento.includes("SALDO") || record.tipoLancamento.includes("Transferência")) ? record.clienteFornecedor : record.historicoTransferencia}
        </Typography.Text>
      ),
    },
    {
      title: "Nº DOC.",
      dataIndex: "numeroDocumento",
      width: 80,
    },
    {
      title: "HISTÓRICO",
      dataIndex: "historico",
      render: (_, record) => (
        <Typography.Text style={{ width: 300 }} ellipsis={{ tooltip: record.historico }}>
          {record.historico}
        </Typography.Text>
      ),
    },
    {
      title: "VALOR",
      dataIndex: "valorTransacao",
      align: "right",
      width: 150,
      render: (_, record) =>
        record.es < 0 ? (
          <p style={{ color: "red", marginBottom: "0px" }}>{record.valorTransacao !== null && currencyBRL(record.valorTransacao)}</p>
        ) : (
          <p style={{ color: "blue", marginBottom: "0px" }}>{record.valorTransacao !== null && currencyBRL(record.valorTransacao)}</p>
        ),
    },
    {
      title: "SALDO",
      dataIndex: "saldo",
      align: "right",
      width: 150,
      render: (_, record) =>
        record.saldo < 0 ? (
          <p style={{ color: "red", marginBottom: "0px" }}>{record.saldo !== null && currencyBRL(record.saldo)}</p>
        ) : (
          <p style={{ color: "blue", marginBottom: "0px" }}>{record.saldo !== null && currencyBRL(record.saldo)}</p>
        ),
    },
    {
      title: "",
      dataIndex: "tipo",
      align: "center",
      width: 30,
      render: (_, record) =>
        record.tipo === "PREV" ? (
          <Tooltip title={record.vencido ? "Vencido" : "Não Realizado"}>
            <Icon.ExclamationCircleFilled style={record.vencido ? { color: "red" } : { color: "orange" }} />
          </Tooltip>
        ) : record.tipo === "REAL" ? (
          <Tooltip title="Realizado">
            <Icon.CheckCircleFilled size={32} style={{ color: "green" }} />
          </Tooltip>
        ) : (
          <></>
        ),
    },
    {
      title: "#",
      dataIndex: "temAnexo",
      align: "center",
      width: 50,
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) =>
        record.temAnexo && (
          <Button size="small" onClick={() => goVisualizarArquivos(record)}>
            <Icon.PaperClipOutlined />
          </Button>
        ),
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      fixed: "right",
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) =>
        !record.tipoLancamento.includes("SALDO") && (
          <AcoesComponent
            record={record}
            items={
              record.tipoLancamento === "Transferência" ? itemsTransferencia : record.tipoLancamento === "Pagamento" || record.tipoLancamento === "Recebimento" ? itemsPagamento : itemsContaFinanceira
            }
          />
        ),
    },
  ];

  return (
    <Flex vertical>
      <Filtro abrir={openFiltros} funcao={onChangeMostrarFiltros} />
      {openFiltros && <FiltroComponent idEmpresa={idEmpresa ? idEmpresa : lancamentoBancarioState.busca.idEmpresa} origem={"lancamentoBancario"} />}
      <Form form={form} layout="vertical" style={openFiltros ? { marginTop: "0px" } : { marginTop: "8px" }}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              {persistedState.user.empresa === null && (
                <Form.Item
                  label="Empresa"
                  name="idEmpresa"
                  rules={[
                    {
                      required: true,
                      message: "Campo obrigatório",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="labelSearch"
                    placeholder="Selecione uma empresa"
                    loading={empresaState.loading}
                    onChange={onChangeEmpresa}
                    style={{ width: 300 }}
                    options={empresaState.list.map((a: EmpresaModel) => ({
                      value: a.id,
                      key: a.apelido,
                      label: (
                        <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                          <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                          {a.apelido}
                        </Flex>
                      ),
                      labelSearch: a.apelido,
                    }))}
                  />
                </Form.Item>
              )}
              <Form.Item
                label="Tipo de data"
                name="tipoDataFiltro"
                rules={[
                  {
                    required: true,
                    message: "Campo obrigatório",
                  },
                ]}
              >
                <Select onChange={onChangeTipoData} style={{ width: 150 }} options={tipoDataOptions} />
              </Form.Item>
              <Form.Item
                label="Data início"
                name="dataInicio"
                rules={[
                  {
                    required: true,
                    message: "Campo obrigatório",
                  },
                ]}
              >
                <DatePicker placeholder="" onChange={onChangeDataInicio} format="DD/MM/YYYY" allowClear={false} style={{ width: 120 }} />
              </Form.Item>
              <Form.Item
                label="Data fim"
                name="dataFim"
                rules={[
                  {
                    required: true,
                    message: "Campo obrigatório",
                  },
                ]}
              >
                <DatePicker placeholder="" onChange={onChangeDataFim} format="DD/MM/YYYY" allowClear={false} style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label=" ">
                <Tooltip title="Atualizar">
                  <Button icon={<Icon.RedoOutlined />} className="buttonPrimary" onClick={atualizar} />
                </Tooltip>
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end" gap={12}>
              <Form.Item label=" ">
                <Dropdown menu={{ items: itemsRelatorio }}>
                  <Button icon={<Icon.PrinterOutlined />} />
                </Dropdown>
              </Form.Item>
              {verificarPermissaoEmpresa() && (
                <Form.Item name="botaoTransferencia" label=" ">
                  <Dropdown menu={{ items: itemsNovo }} trigger={["click"]}>
                    <Button icon={<Icon.PlusCircleOutlined />} style={{ width: "100%" }} className="buttonPrimary">
                      NOVO
                    </Button>
                  </Dropdown>
                </Form.Item>
              )}
            </Flex>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item label="Status" name="status">
              <Checkbox.Group style={{ width: "100%" }} onChange={onChangeCheckbox}>
                <Icon.CheckCircleFilled size={32} style={{ color: "green" }} />
                <Checkbox value={checkboxOptions[1].value}>
                  {checkboxOptions[1].label} ({lancamentoBancarioState.list.filter((a) => a.tipo === "REAL").length})
                </Checkbox>
                <Icon.ExclamationCircleFilled style={{ color: "red" }} />
                <Checkbox value={checkboxOptions[2].value}>
                  {checkboxOptions[2].label} ({lancamentoBancarioState.list.filter((a) => a.tipo === "PREV" && a.vencido === true).length})
                </Checkbox>
                <Icon.ExclamationCircleFilled style={{ color: "orange" }} />
                <Checkbox value={checkboxOptions[0].value}>
                  {checkboxOptions[0].label} ({lancamentoBancarioState.list.filter((a) => a.tipo === "PREV" && a.vencido === false).length})
                </Checkbox>
              </Checkbox.Group>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <TableComponent
        data={lancamentoBancarioState.list.filter((a) => a.tipo !== "SLDP" && a.tipo !== "SLDF")}
        columns={columns}
        loading={lancamentoBancarioState.loading}
        rowKey="ordem"
        tableProps={{
          onRow: (record: LancamentoBancarioModel) => {
            return {
              onClick: () => {
                if (record.id === null) {
                  return;
                }
                goVisualizar(record);
              },
            };
          },
          rowClassName: (record: any) => {
            return record.tipoLancamento.includes("SALDO") ? "rowColor" : "row_normal";
          },
          summary: (pageData: any) =>
            pageData.length > 0 && (
              <>
                <Table.Summary.Row className="rowFooterCls">
                  <Table.Summary.Cell index={0}></Table.Summary.Cell>
                  <Table.Summary.Cell index={1} colSpan={2}>
                    SALDO DO PERÍODO:
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2} colSpan={3} align="right">
                    <span style={{ color: "blue", marginBottom: "0px" }}>{currencyBRL(somarEntradas())}</span> -&nbsp;
                    <span style={{ color: "red", marginBottom: "0px" }}>{currencyBRL(somarSaidas())}</span> =&nbsp;
                    {somarEntradas() > somarSaidas() ? (
                      <span style={{ color: "blue", marginBottom: "0px" }}>{currencyBRL(somarEntradas() - somarSaidas())}</span>
                    ) : (
                      <span style={{ color: "red", marginBottom: "0px" }}>{currencyBRL(somarEntradas() - somarSaidas())}</span>
                    )}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3} colSpan={3}></Table.Summary.Cell>
                </Table.Summary.Row>
                <Table.Summary.Row className="rowFooterCls">
                  <Table.Summary.Cell index={0}></Table.Summary.Cell>
                  <Table.Summary.Cell index={1} colSpan={4}>
                    SALDO ATUAL:
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={4} align="right">
                    {lancamentoBancarioState.list.find((a) => a.tipo === "SLDF")?.saldo! > 0 ? (
                      <span style={{ color: "blue", marginBottom: "0px" }}>{currencyBRL(lancamentoBancarioState.list.find((a) => a.tipo === "SLDF")?.saldo)}</span>
                    ) : (
                      <span style={{ color: "red", marginBottom: "0px" }}>{currencyBRL(lancamentoBancarioState.list.find((a) => a.tipo === "SLDF")?.saldo)}</span>
                    )}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2} colSpan={3}></Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            ),
        }}
      />
      <Modal
        title={editar ? "ATUALIZAR TRANSFERÊNCIA BANCÁRIA" : "NOVA TRANSFERÊNCIA BANCÁRIA"}
        centered
        width={1000}
        open={lancamentoBancarioState.modalCadastrar}
        onCancel={closeModalCadastrar}
        footer={null}
        destroyOnHidden
      >
        <ModalLançamento idEmpresa={idEmpresa ? idEmpresa : lancamentoBancarioState.busca.idEmpresa} />
      </Modal>
      <Modal title={"CONFIRMAR OPERAÇÃO"} centered width={350} open={lancamentoBancarioState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal text={mensagemModal} action={deletarLancamentoBancario({ value: entityToDelete, busca: lancamentoBancarioState.busca })} close={setModalDeletarLancamentoBancario(false)} />
      </Modal>
      <Drawer width={260} title="VISUALIZAR ANEXOS" placement="right" onClose={closeVisualizarArquivo} open={openVisualizarArquivos} getContainer={false}>
        <VisualizarArquivosLancamento />
      </Drawer>
      <Drawer title="VISUALIZAR RESUMO" width={400} placement="right" onClose={onCloseDrawer} open={openDrawer} getContainer={false}>
        <VisualizarLancamentoBancario lancamento={lancamentoBancarioState.entity} />
      </Drawer>
    </Flex>
  );
};

export default GeralPage;
